/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');
var Syphon = require('backbone.syphon');

var toggleForm = require('common/util/toggleForm');
var AddressDisplayView = require('common/views/AddressDisplayView');

var tmplDepLocationDetailsSectionView = require('../templates/DepLocationDetailsSectionView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplDepLocationDetailsSectionView,

  className: 'dep-location-details-section-view',

  ui: {
    addressContainer: '.address-container',
    activityType: '.activity-type',
    relocatedTo: '.relocated-to'
  },

  regions: {
    addressContainer: '@ui.addressContainer'
  },

  onBeforeShow: function() {
    var entityIdentifiers = this.model.get('entityIdentifiers');
    var statusId = this.model.get('statusId');

    toggleForm(this.ui.activityType, entityIdentifiers.categoryId === '1');
    toggleForm(this.ui.relocatedTo, statusId === '7');

    Syphon.deserialize(this, this.model.toJSON());

    this.showChildView(
      'addressContainer',
      new AddressDisplayView({
        model: this.model
      })
    );
  }
});
